import { type FC } from 'react';

import { Box, Ribbon, Stack, Text } from '@eneco/sparky';
import { GiftIcon } from '@eneco/sparky/icons';

import { typeTheme } from './PriceDetails.theme';
import { type TitleProps } from './PriceDetails.types';
import { DetailsType } from '../../types';

export const Title: FC<TitleProps> = ({ type, backgroundColor, textColor, icon, children }) => {
  let theme = typeTheme[DetailsType.Electricity];

  if (type) {
    theme = typeTheme[type];
  } else if (backgroundColor && textColor) {
    theme = { backgroundColor, textColor, icon };
  }

  if (type === DetailsType.Cashback) {
    return (
      <Ribbon>
        <Box paddingX="3" paddingY="1">
          <Stack direction="row" alignY="center" gap="1">
            <GiftIcon color="iconInverted" />
            <Text weight="bold" size="BodyM" color="textInverted">
              {children}
            </Text>
          </Stack>
        </Box>
      </Ribbon>
    );
  }

  return (
    <Box backgroundColor={theme.backgroundColor} padding="3">
      <Stack direction="row" alignY="center" gap="1">
        {theme.icon}
        <Text weight="bold" color={theme.textColor}>
          {children}
        </Text>
      </Stack>
    </Box>
  );
};
